import { capturePageView } from "@/app/_analytics/analytics";
import { usePathname, useSearchParams } from "next/navigation";
import { useEffect } from "react";

export const useCapturePageViews = () => {
  const pathname = usePathname();
  const searchParams = useSearchParams();

  useEffect(() => {
    if (pathname) {
      let url = window.origin + pathname;
      if (searchParams && searchParams.toString()) {
        url = url + `?${searchParams.toString()}`;
      }
      capturePageView(url);
    }
  }, [pathname, searchParams]);
};
